/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import CostHintBox from "@/src/components/Serviceworld/Settlement/CostsHintBox/CostHintBox";
import PoaAgreementText from "@/src/components/Form/Common/PowerOfAttorney/PoaAgreementText";
import { useForm } from "@/src/provider/Form/FormProvider";
import Signature from "@/src/components/Form/Common/Signature/Signature";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { Box } from "@mui/material";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";

type PowerOfAttorneyProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

const PowerOfAttorney = ({ product, submitProps }: PowerOfAttorneyProps) => {
  const { handleSubmit } = useForm();

  return (
    <div>
      <ContentBox headline={<strong>Vollmacht</strong>} headlineVariant={"h5"} showDivider={true}>
        <Box component={"form"} id={"application-form"} onSubmit={handleSubmit}>
          <div>
            <p>
              Hiermit erteile ich den Legalbird Rechtsanwälten (Legalbird Rechtsanwälte Rechtsanwalts GmbH) in meiner Arbeitsrechtssache die Vollmacht zur
              außergerichtlichen Vertretung aller Art und die Prozessvollmacht für alle Verfahren in allen Instanzen.
            </p>
            <p>
              Die Vollmacht ermächtigt zu allen den Rechtsstreit betreffenden Prozesshandlungen, insbesondere zur Bestellung eines Vertreters, zur Beseitigung
              des Rechtsstreits durch Vergleich, Verzicht und Anerkenntnis, ferner zur Empfangnahme von Geldern und der vom Gegner, der Justizkasse oder anderen
              Stellen zu erstattenden Kosten.
            </p>
            <p>Die Befugnis umfasst auch die Übertragung der Vollmacht ganz oder teilweise auf andere.</p>
            <p>
              Mir ist bekannt, dass mit der Vollmacht eine Beauftragung und damit eine Anwaltsvergütung entsteht, deren Höhe abhängig vom Verfahrenswert ist,
              der vom Gericht festgesetzt wird. Diese Kosten werden gemäß der{" "}
              <LinkLegalbird target={"_blank"} to={"/agb-prozessfinanzierung"}>
                Legalbird Prozessfinanzierungs AGB
              </LinkLegalbird>{" "}
              übernommen.
            </p>
            <p>Die Bearbeitung meines Mandats erfolgt vorbehaltlich der Annahme durch die {product.lawFirm.name}.</p>
            <PoaAgreementText lawFirmName={product.lawFirm.name} hasNoWinNoFeeClause={true} />
          </div>
          <Signature product={product} person={product.client} />
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "baseline"
            }}>
            <Grid size={12}>
              <ButtonLoading
                color="primary"
                variant="contained"
                type="submit"
                fullWidth={true}
                disabled={!product.client.signature}
                isLoading={submitProps.isLoading}
              >
                Vollmacht erteilen und beauftragen
              </ButtonLoading>
            </Grid>
            <Grid />
            <Grid size={12}>
              <CostHintBox settlement={product} />
            </Grid>
          </Grid>
        </Box>
        <EmailVerificationModal />
      </ContentBox>
    </div>
  );
};
export default PowerOfAttorney;
